<div *ngIf="loading === 0" class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <dx-form #form1 [labelLocation]="'top'" [colCount]="1" [formData]="init_data.ue">

                <dxi-item dataField="verwaltungsgerichtId" editorType="dxSelectBox" [editorOptions]="{ items: init_data.available_Verwaltungsgerichte, displayExpr: 'name', valueExpr: 'id'   }" [label]="{text: 'Verwaltungsgericht'}">
                    <dxi-validation-rule type="required" message="'Verwaltungsgericht' wird benötigt!"></dxi-validation-rule>
                </dxi-item>

                <dxi-item itemType="group" [colCount]="4">
                    <dxi-item [colSpan]="1" [label]="{text: 'Von'}" dataField="von" editorType="dxDateBox">
                        <dxi-validation-rule type="required" message="'Von' wird benötigt!"></dxi-validation-rule>
                        <dxi-validation-rule type="custom"
                                             [validationCallback]="dateValidationCallback"
                                             [reevaluate]="true"
                                             [min]="nowDate"
                                             [max]="maxDate"
                                             message="Jahr muss zwischen heute und 2099 liegen!">
                        </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item [colSpan]="1" [label]="{text: 'Bis'}" dataField="bis" editorType="dxDateBox">
                        <dxi-validation-rule type="required" message="'Bis' wird benötigt!"></dxi-validation-rule>
                        <dxi-validation-rule type="custom"
                                             [validationCallback]="dateValidationCallback"
                                             [reevaluate]="true"
                                             [min]="nowDate"
                                             [max]="maxDate"
                                             message="Jahr muss zwischen heute und 2099 liegen!">
                        </dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="Bemerkung">
                    <dxi-item dataField="bemerkung" editorType="dxTextArea" [editorOptions]="{ height: 200 }">
                        <dxo-label [visible]="false"></dxo-label>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div *ngIf="loading === 1" class="text-center">
                <h1>Lade...</h1>
            </div>
            <div *ngIf="loading === 2" class="text-center">
                <h1>Speichere...</h1>
            </div>
        </div>
    </div>
</div>
